import * as React from "react";

export const SvgJOSFuel = (props) => (
	<svg width={37} height={37} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x={0.5} y={0.5} width={36} height={36} rx={8} fill="#FFF8EA" />
		<path
			d="M11.7 8.9c-.873 0-1.6.727-1.6 1.6v16.8a.8.8 0 0 0 .8.8h9.6a.8.8 0 0 0 .8-.8v-3.6c0-.22.179-.4.4-.4h.4c.45 0 .8.349.8.8v.8c0 1.316 1.084 2.4 2.4 2.4 1.316 0 2.4-1.084 2.4-2.4V14.5c0-.755-.356-1.467-.96-1.92l-2.56-1.92a.802.802 0 0 0-1.121.16.802.802 0 0 0 .16 1.12l.96.72a.8.8 0 0 1 .32.64v2c0 .738.518 1.37 1.205 1.55.214.056.396.23.396.45v7.6c0 .451-.35.8-.8.8a.788.788 0 0 1-.8-.8v-.8c0-1.316-1.084-2.4-2.4-2.4h-.4a.4.4 0 0 1-.4-.4V10.5c0-.873-.728-1.6-1.6-1.6h-8Zm.4 1.6h7.2a.4.4 0 0 1 .4.4v5.6a.4.4 0 0 1-.4.4h-7.2a.4.4 0 0 1-.4-.4v-5.6a.4.4 0 0 1 .4-.4Z"
			fill="#FFB11A"
		/>
	</svg>
);
